import { NgModule } from "@angular/core";

import { FilterPipe } from "@core/pipes/filter.pipe";

import { InitialsPipe } from "@core/pipes/initials.pipe";

import { SafePipe } from "@core/pipes/safe.pipe";
import { StripHtmlPipe } from "@core/pipes/stripHtml.pipe";
import { CustomCurrencyPipe } from "./custom-currency.pipe";
import { CurrencyCommasHundredsPipeLanding1 } from "./currency-commas-hundreds-landing-1.pipe";

@NgModule({
  declarations: [
    InitialsPipe,
    FilterPipe,
    StripHtmlPipe,
    SafePipe,
    CustomCurrencyPipe,
    CurrencyCommasHundredsPipeLanding1,
  ],
  imports: [],
  exports: [InitialsPipe, FilterPipe, StripHtmlPipe, SafePipe, CustomCurrencyPipe, CurrencyCommasHundredsPipeLanding1],
})
export class CorePipesModule {}
